import React, { Component } from 'react'
import { Col } from 'react-bootstrap'
import moment from 'moment'
import SliderSlick from 'react-slick'
import Spinner from '../../../../components/Spinner'
import { Link } from 'react-router'
import { translate } from "react-translate"
import { ShareButton } from '../../../commons/ShareButton/ShareButton.component'

import './NewsSlider.scss'

@translate("Noticias")
export default class Noticias extends Component {

  _renderDate(date){
    moment.locale('es');
    var m = moment(date)
    let day = moment(m).format('dddd')
    let newDate = moment(m).format('LL')
    return (<p className="date-reference">{day} &emsp;{newDate}</p>)
  }

  bannerNext(e) {
    e.preventDefault()
    e.stopPropagation()
    // eslint-disable-next-line react/no-string-refs
    this.refs.sliderImi.slickNext()
  }

  bannerPrevious(e) {
    e.preventDefault()
    e.stopPropagation()
    // eslint-disable-next-line react/no-string-refs
    this.refs.sliderImi.slickPrev()
  }

  render () {

  	const { news, t, classContainer } = this.props

    const bannerSettings = {
      dots: false,
      arrows: false,
      speed: 400,
      autoplay: false,
      slidesToShow: 4,
      slidesToScroll: 1,
      touchMove: true,
      responsive: [
        { breakpoint: 1024, settings: { slidesToShow: 2 } },
        { breakpoint: 768, settings: { slidesToShow: 1, dots: true } },
      ]
    }

  	if (news) {
      return (
        <div className={`ljr-slider-container ${classContainer}`}>
          <Link className='btn ljr-slider-view-more-items hidden-xs' to='/noticias'>
            {t('ver_todas_las_noticias')}
          </Link>
          <h1>{t('Ultimas_Noticias')}</h1>
          <div className='banners-container'>
            <SliderSlick className='slider-banners-container' ref='sliderImi' {...bannerSettings}>
              {news.map((item, index) =>
                <Col md={3} sm={12} key={index} >
                    <div className='slider-template-news news-slider-item'>
                      <ShareButton shareUrl={item.link} />
                      <div className="slider-image" style={{backgroundImage: 'url(' + item.image + ')'}}>
                        <div className="overlay-img"></div>
                      </div>
                      <div className="slider-item-detail">
                        <Link href={item.link} target='_blank'>
                          <h2 className='new-slider-title'>{item.title}</h2>
                          <h3 className='new-slider-subtitle'>{item.description_seo}</h3>
                        </Link>
                        {this._renderDate(item.date)}
                      </div>
                    </div>
                </Col>
              )}
            </SliderSlick>
            <div className='ljr-slider-buttons'>
              <div className='ljr-slider-left-buttons'>
                <a onClick={(e) => {this.bannerPrevious(e)}}>
                  <i className='fa fa-angle-left fa-2x' aria-hidden='true'></i>
                </a>
              </div>
              <div className='ljr-slider-right-buttons'>
                <a onClick={(e) => {this.bannerNext(e)}}>
                  <i className='fa fa-angle-right fa-2x' aria-hidden='true'></i>
                </a>
              </div>
            </div>
            <div className='text-center visible-xs'>
              <Link className="btn ljr-slider-view-more-items-mobile" to="/informes-del-mercado-inmobiliario">{t("ver_todas_las_noticias")}</Link>
            </div>
          </div>
        </div>
      )
  	}
  	else{
  		return (
	    	<Spinner />
	    )
  	}
  }
}



// WEBPACK FOOTER //
// ./src/features/PageHome/components/Noticias/index.js